import { render, staticRenderFns } from "./OInfoSaleComp.vue?vue&type=template&id=05dae305&"
import script from "./OInfoSaleComp.vue?vue&type=script&lang=js&"
export * from "./OInfoSaleComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports